var KLAVIYO_PUBLIC_KEY = 'Vphnsz';
var KLAVIYO_LIST_ID = 'TqRANd'; // ← Replace with your new Klaviyo list ID

// ─── QUESTIONS ────────────────────────────────────────────────────────────────
// Q1–Q5: Health signals (current state)
// Q6: Aspirational (goals and forward-looking intent)
// Q7–Q8: Lifestyle signals (format logic)

var questions = [
  {
    q: "How would you describe your energy on a typical day?",
    opts: [
      { text: "I crash in the afternoon and struggle to get through", scores: { energy: 3 } },
      { text: "I feel sluggish waking up, even after a full night's sleep", scores: { energy: 2, gut: 1 } },
      { text: "Pretty steady, though I could use more spark", scores: { overall: 2 } },
      { text: "Good — I feel energised most of the time", scores: { overall: 1 } }
    ]
  },
  {
    q: "How does your gut feel after eating?",
    opts: [
      { text: "Bloated, uncomfortable or sluggish — fairly often", scores: { gut: 3 } },
      { text: "Unpredictable — some meals are fine, others not", scores: { gut: 2 } },
      { text: "Generally fine but I know my diet could be better", scores: { overall: 2 } },
      { text: "Settled — digestion isn't something I think about", scores: { overall: 1 } }
    ]
  },
  {
    q: "How regular are your bowel movements?",
    opts: [
      { text: "Irregular — I often go days without", scores: { gut: 3 } },
      { text: "I go daily but it's uncomfortable or unpredictable", scores: { gut: 2 } },
      { text: "Mostly regular but affected by stress or diet", scores: { gut: 1, overall: 1 } },
      { text: "Regular and consistent — no issues", scores: { overall: 1 } }
    ]
  },
  {
    q: "How often do you get coughs, colds or feel run down?",
    opts: [
      { text: "Constantly — I seem to catch everything going", scores: { immune: 3 } },
      { text: "A few times a year and it takes me a while to bounce back", scores: { immune: 2 } },
      { text: "Occasionally, but I recover quickly", scores: { overall: 1 } },
      { text: "Rarely — my immune system feels solid", scores: { overall: 1 } }
    ]
  },
  {
    q: "What does your diet look like most days?",
    opts: [
      { text: "Mostly processed or on the go — fresh food is rare", scores: { gut: 2, immune: 1, energy: 1 } },
      { text: "Hit and miss — good intentions, patchy in practice", scores: { overall: 2, gut: 1 } },
      { text: "Reasonably healthy but I want to add more nutrition", scores: { overall: 2 } },
      { text: "I eat well and prioritise whole foods", scores: { overall: 1 } }
    ]
  },
  {
    // NEW in v3: Aspirational question — catches proactive buyers, not just those with symptoms.
    // Scores add to health priority so forward-looking goals inform the recommendation.
    q: "What matters most to you looking ahead?",
    opts: [
      { text: "Staying well as I get older — long-term health and healthy ageing", scores: { overall: 2 } },
      { text: "More consistent energy and mental clarity day to day", scores: { energy: 2 } },
      { text: "A gut that settles — and I don't have to think about it", scores: { gut: 2 } },
      { text: "Building real resilience — getting ill less, recovering faster", scores: { immune: 2 } }
    ]
  },
  {
    q: "What does your day-to-day life look like?",
    opts: [
      { text: "Home-based and fairly routine", scores: { home: 2 } },
      { text: "Busy and always on the go, but mostly based at home", scores: { home: 1, travel: 1 } },
      { text: "Travelling frequently or a very unpredictable schedule", scores: { travel: 3 } }
    ]
  },
  {
    q: "Which sounds most like you?",
    opts: [
      { text: "I want a simple daily ritual — no prep, just done", scores: { ritual: 2 } },
      { text: "I love cooking and want real food on my plate", scores: { food: 2 } },
      { text: "A mix — cooking some evenings, something effortless on busy days", scores: { food: 1, ritual: 1 } },
      { text: "I already have a smoothie or supplement routine I could add to", scores: { powder: 2 } }
    ]
  }
];

// ─── HEALTH LABELS ────────────────────────────────────────────────────────────
var healthLabels = {
  gut:     "Gut health",
  energy:  "Energy & nutrition",
  immune:  "Immune resilience",
  overall: "Preventive health"
};

// ─── HEALTH SIGNAL INTERPRETATION ─────────────────────────────────────────────
var signalsCopy = {
  gut: "Your gut is sending some clear signals. Bloating, irregular bowel movements and discomfort after eating often point to an imbalance in the gut microbiome — the trillions of bacteria that live in your digestive tract and influence everything from digestion and immunity to mood and energy. The good news is that the gut is highly responsive to the right nutritional support.",
  energy: "Your energy patterns suggest your body may be running on a nutrient deficit. Afternoon crashes and sluggish mornings are frequently caused by micronutrient gaps rather than sleep alone — your cells need a broad and consistent supply of vitamins, minerals and phytonutrients to produce energy efficiently, and most modern diets leave quiet gaps, even good ones.",
  immune: "Your immune system appears to be working harder than it should. Frequent illness and slow recovery often reflect a depleted defence system — usually a combination of micronutrient shortfalls, chronic low-grade inflammation, and a gut microbiome that isn't supporting immunity as effectively as it could. All of these respond well to consistent, targeted nutrition.",
  overall: "Your results suggest you're in reasonable shape and want to stay that way. Proactive nutrition — filling the gaps before symptoms appear — is one of the most effective long-term health strategies available. You don't have to be unwell to benefit significantly from better food."
};

// ─── SECONDARY SIGNAL NOTES ───────────────────────────────────────────────────
// Brief acknowledgement when a secondary health signal also came through.
var secondarySignalNote = {
  gut:    "often a downstream effect of the same nutritional gaps — and the two tend to improve together",
  energy: "often a downstream effect of the same nutritional gaps — more consistent nutrition typically improves both",
  immune: "closely connected to gut health and nutrient status — the recommended format supports all three"
};

// ─── ANSWER OPENERS ───────────────────────────────────────────────────────────
// References the specific thing the person said to open the signals section.
// selectedAnswerTexts[idx] stores the text of the selected option per question.
function getAnswerOpener(healthKey, texts) {
  if (healthKey === 'gut') {
    if (texts[1] && texts[1].indexOf('Bloated') > -1)
      return "You told us your gut often feels bloated and uncomfortable after eating.";
    if (texts[1] && texts[1].indexOf('Unpredictable') > -1)
      return "You told us your gut is unpredictable — some meals settle fine, others don't.";
    if (texts[2] && texts[2].indexOf('Irregular') > -1)
      return "You told us your bowel movements are irregular — often days between.";
    if (texts[2] && texts[2].indexOf('uncomfortable') > -1)
      return "You told us your digestion is uncomfortable even when it's regular.";
    return "Your answers point clearly to your gut as the priority.";
  }
  if (healthKey === 'energy') {
    if (texts[0] && texts[0].indexOf('crash') > -1)
      return "That afternoon energy crash you mentioned — struggling to get through — is a clear nutritional signal.";
    if (texts[0] && texts[0].indexOf('sluggish waking up') > -1)
      return "Feeling sluggish waking up, even after a full night's sleep, is one of the clearest signs of a micronutrient gap.";
    return "Your answers point to energy as the priority.";
  }
  if (healthKey === 'immune') {
    if (texts[3] && texts[3].indexOf('Constantly') > -1)
      return "You told us you seem to catch everything going — that frequency matters. It's your immune system asking for consistent support.";
    if (texts[3] && texts[3].indexOf('few times') > -1)
      return "Getting ill a few times a year and taking a while to bounce back is your immune system telling you it needs more to work with.";
    return "Your answers point to immune resilience as the priority.";
  }
  if (healthKey === 'overall') {
    if (texts[0] && texts[0].indexOf('Pretty steady') > -1)
      return "Your energy is steady and your gut is settled — you're not coming to this from a place of discomfort. That's actually the best time to invest in your nutrition.";
    return "Your results suggest you're in reasonable shape. That's the best time to invest in your nutrition — before gaps become symptoms.";
  }
  return "";
}

// ─── RESEARCH CONTENT ─────────────────────────────────────────────────────────
// Vivid translations added alongside the raw numbers so the scale lands.
var scienceCopy = {
  gut: {
    intro: "The relationship between microgreens and gut health is increasingly well-documented. Here's what the research shows:",
    facts: [
      { text: "Brassica microgreens — broccoli, red cabbage, radish — are rich in glucosinolates, which break down during digestion into compounds including sulforaphane. These have been shown to support a healthy gut lining and reduce gut inflammation.", ref: "Ninh Le T et al., 2020" },
      { text: "Research published in 2025 found that polyphenols in microgreens can influence the composition of the gut microbiome — with potential prebiotic effects linked to increased populations of beneficial bacteria.", ref: "Garcia-Perez P et al., 2025" },
      { text: "Red cabbage microgreens have been shown to lower inflammatory markers including C-reactive protein — one of the key drivers of digestive discomfort — in controlled studies.", ref: "Choe U et al., 2018" }
    ]
  },
  energy: {
    intro: "Why microgreens specifically for energy? The answer lies in nutrient density and bioavailability — two things most food sources can't match:",
    facts: [
      { text: "Vitamin C content in commercially available microgreens ranges from 29.9 to 123.3mg per 100g fresh weight — comparable to citrus fruit. Crucially, because microgreens are eaten raw, none is lost to cooking.", ref: "Zhang Y et al., 2021" },
      { text: "Microgreens consistently show higher mineral concentrations than mature vegetables. This is explained by the dilution effect: as plants grow, increased biomass spreads nutrients more thinly. At the microgreen stage, that hasn't happened yet.", ref: "Bhaswant M et al., 2025" },
      { text: "Vitamin C in red cabbage microgreens has been measured at 147mg per 100g — six times higher than mature red cabbage at 24.4mg/100g, and nearly three times the amount found in a fresh orange (about 53mg/100g).", ref: "Xiao Z et al., 2012" }
    ]
  },
  immune: {
    intro: "Microgreens contain some of the highest concentrations of immune-supportive compounds found in any food. The numbers are striking:",
    facts: [
      { text: "Red cabbage microgreens contain approximately 260 times more beta-carotene than the same plant fully grown. To match that amount from mature red cabbage, you'd need to eat over 2.5kg of it. Beta-carotene is a potent antioxidant and precursor to Vitamin A — both essential for immune function.", ref: "Xiao Z et al., 2012" },
      { text: "Red cabbage microgreens contain over 40 times the Vitamin E content of mature red cabbage — a nutrient critical for immune cell function and protection against oxidative stress. That's the equivalent of eating 40 portions of mature red cabbage in a single handful of microgreens.", ref: "Xiao Z et al., 2012" },
      { text: "Sulforaphane — found in high concentrations in broccoli microgreens — is a Nrf2 inducer, activating the body's own antioxidant pathways. Multiple studies link it to reduced inflammatory markers and stronger immune resilience.", ref: "Lone JK et al., 2024" }
    ]
  },
  overall: {
    intro: "Even when you're feeling well, microgreens offer nutritional density that's difficult to get from any other food source:",
    facts: [
      { text: "A 2021 review concluded that microgreens consistently show higher concentrations of vitamins C, E and K, and a range of antioxidant compounds, compared to mature vegetables — making them among the most nutrient-dense foods available.", ref: "Zhang Y et al., 2021" },
      { text: "Red cabbage microgreens contain over 40 times the Vitamin E of mature red cabbage, and 260 times more beta-carotene. To get the same beta-carotene from mature red cabbage, you'd need to eat over 2.5kg of it.", ref: "Xiao Z et al., 2012" },
      { text: "Microgreens are nutrient-dense and low in sugar — a combination that supports metabolic health, steady energy and long-term wellbeing without adding unnecessary load to the diet.", ref: "Bhaswant M et al., 2023" }
    ]
  }
};

// ─── FORMAT × HEALTH RATIONALE ────────────────────────────────────────────────
var formatHealthCopy = {
  bigshot: {
    gut: "Big Shot is our strongest format for gut health. It's a live product — the fermentation process keeps the active cultures alive, so when you drink it they're working immediately in your digestive tract. That's what makes it genuinely different from a dried supplement or powder.",
    energy: "The five microgreens in Big Shot are cold pressed to preserve their nutrients, then fermented — a process that increases bioavailability of many compounds. A daily 30ml shot delivers a broad micronutrient profile that most diets, even good ones, consistently miss.",
    immune: "Big Shot combines the concentrated antioxidant and anti-inflammatory properties of five microgreens with the live cultures from wild fermentation — supporting both your immune cells and the gut microbiome that regulates 70% of immune function.",
    overall: "Big Shot is the simplest way to add meaningful nutritional density to your day — 30 seconds, 30ml, every morning. One consistent daily habit that fills the gaps even a good diet tends to leave."
  },
  fresh: {
    gut: "Fresh microgreens eaten raw deliver their glucosinolates and fibre intact — undamaged by heat or processing. These compounds feed a healthy gut lining and support the diversity of your gut microbiome in a way that processed foods simply cannot.",
    energy: "Fresh microgreens are harvested at the point of peak nutrient concentration. Eating them within days of harvest — rather than weeks, as with supermarket vegetables — means the vitamins and phytonutrients are at their highest and most bioavailable.",
    immune: "Raw microgreens preserve every bit of their natural Vitamin C, beta-carotene and antioxidant compounds — none lost to cooking. For immune support, fresh is the most potent form.",
    overall: "Fresh microgreens are the most direct nutritional upgrade you can make to your diet — real food, extraordinary density, nothing processed. The full experience of what a plant can offer."
  },
  powder: {
    gut: "The powder is made from the same five-microgreen ferment as Big Shot — cold pressed, fermented in salt brine, then dehydrated at 40°C. That low temperature preserves the live cultures and enzymes. Your gut gets the same support whether you're home or on the road.",
    energy: "The powder concentrates the same five microgreens as Big Shot into a shelf-stable format. Low-temperature dehydration preserves the vitamin and mineral profile — the nutrients that most directly support consistent energy are intact.",
    immune: "Dehydrating at 40°C rather than high temperatures preserves the antioxidants, glucosinolates and Vitamin C that make microgreens exceptional for immune support. You're getting the real thing, not a heat-processed shadow of it.",
    overall: "The powder is the same nutrition as Big Shot in a format that travels. The fermentation and low-temperature drying process preserves what matters — so whether you're at home or away, your daily nutritional foundation stays consistent."
  },
  'bigshot-powder': {
    gut: "Gut health benefits most from daily, unbroken consistency. Big Shot at home delivers live fermented cultures and concentrated microgreens in their most potent form. The powder ensures you're never without the same nutrition when you travel — made from the same fermented base, dehydrated to preserve the cultures.",
    energy: "Energy responds to consistent daily nutrition more than anything else. Big Shot and the powder are made from the same five-microgreen ferment — so whether you're at home or on the road, your cells get the same daily supply of the nutrients they need.",
    immune: "Immune support is cumulative — gaps in your routine undo progress. Big Shot at home, powder when you travel, means your micronutrient intake stays consistent whatever the week looks like.",
    overall: "The combination of Big Shot and powder means your daily nutritional foundation is protected whether or not your routine holds. Two formats, one plant, no gaps."
  },
  'fresh-bigshot': {
    gut:     "Fresh microgreens on cooking evenings deliver raw glucosinolates and fibre directly into the gut. Big Shot on busy days provides the live fermented cultures that work on your microbiome from within. Between them, your gut gets consistent support in two genuinely complementary ways.",
    energy:  "Fresh microgreens give you peak-potency nutrients at the moment of harvest — highest bioavailability of anything we make. Big Shot fills the gaps on the days when eating well is hard. Consistent energy needs consistent nutrition, and this combination doesn't leave gaps.",
    immune:  "Raw fresh microgreens preserve their full Vitamin C and antioxidant load — the most potent form for immune support. Big Shot's fermented live cultures complement that by supporting the gut microbiome that regulates immune function. Two angles, one goal.",
    overall: "Fresh microgreens for the full culinary and nutritional experience when you're cooking. Big Shot for effortless daily consistency when you're not. For someone who wants microgreens to genuinely fit their life — rather than reshaping their life around them — this is the right combination."
  },
  'fresh-powder': {
    gut: "Fresh microgreens feed your gut microbiome through fibre, glucosinolates and live plant compounds. The powder — made from the same fermented five-microgreen base as Big Shot — supports the gut through live cultures when fresh isn't available. Together they cover all the bases.",
    energy: "Fresh at home gives you peak bioavailability — nutrients at their highest and most intact. Powder when you're travelling means you're not starting from zero when your routine breaks down. Between the two, your energy has consistent nutritional support.",
    immune: "Raw fresh microgreens preserve their Vitamin C and antioxidants fully. The powder preserves them through low-temperature processing. Either way, you're getting the real nutritional value — and consistency is what your immune system needs.",
    overall: "Fresh microgreens when you're home, powder when you're not. Between the two, your daily nutrition stays intact regardless of what your week looks like."
  }
};

// ─── VARIETY DATA ─────────────────────────────────────────────────────────────
var varietyData = {
  'red-cabbage': {
    name: 'Red Cabbage',
    tagline: 'The immune & antioxidant powerhouse',
    size: '30g punnet',
    price: 'From £4.25',
    why: {
      gut:     'Rich in glucosinolates — compounds that support a healthy gut microbiome and reduce gut inflammation. Studies show red cabbage microgreens lowered inflammatory markers including CRP and TNF-α.',
      energy:  'Contains 6× more vitamin C than mature red cabbage — comparable to citrus fruit. Vitamin C is essential for absorbing iron and fuelling consistent cellular energy.',
      immune:  'Contains 260× more β-carotene and 6× more vitamin C than the fully grown plant. One of the most researched microgreens for immune support — a key variety for resilience.',
      overall: 'One of the most nutrient-dense varieties we grow. Broad-spectrum antioxidants, vitamins C, E and K, and anti-inflammatory glucosinolates — exceptional value in a 30g punnet.'
    },
    flavour: 'Mild, slightly earthy. Works on almost anything — eggs, salads, grain bowls.'
  },
  'broccoli': {
    name: 'Broccoli',
    tagline: 'The gut health specialist',
    size: '30g punnet',
    price: 'From £4.25',
    why: {
      gut:     'The richest natural source of sulforaphane — a potent anti-inflammatory compound shown in peer-reviewed research to reduce gut inflammation markers, support beneficial gut bacteria, and relieve insulin resistance.',
      energy:  'Broccoli microgreens influence lipid metabolism and blood glucose regulation — helping your body use energy more efficiently and avoid the spikes and crashes that drain you.',
      immune:  'Sulforaphane activates the Nrf2 antioxidant pathway — one of the body\'s most powerful internal defence systems. Linked to reduced risk of CVD, cancer and metabolic syndrome.',
      overall: 'The most studied microgreen in peer-reviewed science. Linked to reduced LDL, improved insulin sensitivity, and strong anti-cancer and anti-inflammatory properties.'
    },
    flavour: 'Mild, slightly peppery. Versatile on any savoury dish.'
  },
  'pea': {
    name: 'Pea Shoots',
    tagline: 'The energy & protein booster',
    size: '70g punnet',
    price: 'From £3.45',
    why: {
      gut:     'Rich in fibre and gentle on the digestive system. A great daily addition for gut regularity without aggravating sensitivity. The mildest of our core varieties.',
      energy:  'High in plant protein, vitamin C and B vitamins. Vitamin C dramatically improves iron absorption from food — one of the most common and overlooked causes of persistent low energy.',
      immune:  'Good source of vitamin C and zinc, both essential for immune cell production and recovery speed. The largest punnet in our range means more per day for less.',
      overall: 'One of the most approachable and versatile microgreens. Rich in protein, vitamin C and folate — a strong, gentle everyday foundation for better nutrition.'
    },
    flavour: 'Sweet, fresh and mild. The easiest variety for everyday use — children love them too.'
  },
  'sunflower': {
    name: 'Sunflower',
    tagline: 'The antioxidant leader',
    size: '65g punnet',
    price: 'From £4.75',
    why: {
      gut:     'High in healthy fats and magnesium — supports a calmer gut environment and helps reduce the oxidative stress that drives gut inflammation.',
      energy:  'Has the highest free radical scavenging capacity of any variety we grow (81.51% in studies). Antioxidants protect the mitochondria — your cellular energy engines — from oxidative damage.',
      immune:  'Highest antioxidant activity in our core range. Rich in vitamin E and healthy fats — helps neutralise the free radicals that wear down immune defences over time.',
      overall: 'The broadest antioxidant profile in our range. Rich in healthy fats, magnesium and vitamin E — a strong all-rounder for anyone investing in long-term preventive health.'
    },
    flavour: 'Nutty, slightly rich and satisfying. Excellent in salads, on avocado toast, or straight from the punnet.'
  },
  'radish': {
    name: 'Rambo Radish',
    tagline: 'The blood sugar balancer',
    size: '40g punnet',
    price: 'From £3.95',
    why: {
      gut:     'Research shows significant inhibition of α-glucosidase — an enzyme that breaks down carbohydrates. This slows digestion, reduces post-meal blood sugar spikes, and creates a calmer gut environment.',
      energy:  'By moderating blood sugar spikes after meals, radish microgreens help smooth out the energy crashes that follow high-carb eating — keeping your energy more consistent through the day.',
      immune:  'High in vitamin C and anthocyanins — the vibrant red pigments with powerful anti-inflammatory and antioxidant properties. One of the most visually striking and medicinally active varieties.',
      overall: 'Research shows significant blood sugar modulating effects. Useful for anyone managing energy levels or metabolic health proactively. Brilliant flavour and visual impact on any plate.'
    },
    flavour: 'Peppery, vibrant and punchy. Brilliant on eggs, fish, salads and anything that needs a lift.'
  },
  'popcorn-shoots': {
    name: 'Popcorn Shoots',
    tagline: 'The gentle everyday variety',
    size: 'Seasonal',
    price: 'Ask us',
    why: {
      gut:     'Mild and easy to digest. A gentle way to add nutritional variety and plant diversity without challenging a sensitive gut.',
      energy:  'Good source of vitamins A and C — supports the immune and energy systems without any strong or challenging flavours.',
      immune:  'Provides a gentle antioxidant and vitamin C boost. A great gateway variety — loved by children and anyone new to microgreens.',
      overall: 'The friendliest microgreen in our range. Sweet, mild and approachable — a great starting point for building a daily microgreen habit.'
    },
    flavour: 'Sweet, mild, slightly corn-like. Perfect for children or anyone easing into microgreens.'
  },
  'nasturtium': {
    name: 'Nasturtium',
    tagline: "The chef's favourite",
    size: 'Seasonal',
    price: 'Ask us',
    why: {
      gut:     'Contains glucosinolates and natural antibacterial compounds. Has been used traditionally for digestive health — the peppery bite is a sign of its active phytochemicals at work.',
      energy:  'Rich in vitamin C and iron — both essential for energy production. The vibrant colour signals a high concentration of antioxidant compounds throughout.',
      immune:  'High in vitamin C and isothiocyanates — natural compounds with proven antibacterial and anti-inflammatory properties. One of our most medicinally interesting varieties.',
      overall: 'Both beautiful and functional. Rich in vitamin C with antibacterial and anti-inflammatory properties. A chef\'s staple that also earns its place on a health-conscious plate.'
    },
    flavour: 'Peppery, bright and distinctive. The variety chefs reach for first. Edible flowers available seasonally.'
  },
  'coriander': {
    name: 'Micro Coriander',
    tagline: 'The digestive calmer',
    size: 'Seasonal',
    price: 'Ask us',
    why: {
      gut:     'Contains linalool — a natural compound with calming and anti-inflammatory properties. Used for centuries as a digestive aid. One of the most targeted varieties for a settled, comfortable gut.',
      energy:  'Anti-inflammatory properties help reduce the low-grade inflammation that quietly drains energy. Contains B vitamins that support nervous system and energy metabolism.',
      immune:  'Rich in antioxidants and anti-inflammatory compounds. For those who love the flavour, one of the most medicinally active varieties in our range.',
      overall: 'An acquired taste that rewards the adventurous. Intensely flavoured and genuinely functional — anti-inflammatory, digestive-supportive and rich in antioxidants.'
    },
    flavour: 'Intensely coriander — concentrated and aromatic. For those who love it, nothing else comes close.'
  },
  'amaranth': {
    name: 'Amaranth',
    tagline: 'The protein & skin variety',
    size: 'Seasonal',
    price: 'Ask us',
    why: {
      gut:     'High in fibre and betacyanins — the deep red-purple pigments with strong antioxidant and anti-inflammatory effects on the gut lining.',
      energy:  'One of the few plant sources with a complete amino acid profile, including lysine. Supports muscle repair, energy metabolism and consistent daily function — particularly relevant for plant-based diets.',
      immune:  'High in folate, vitamin C and betacyanins. These compounds are linked to reduced inflammation, stronger immune defences and healthy cell turnover.',
      overall: 'Visually striking and nutritionally exceptional. High in protein, folate and betacyanins — particularly relevant for plant-based diets, skin health and healthy ageing.'
    },
    flavour: 'Mild, slightly earthy, with beautiful deep red-purple leaves. Visually stunning on any dish.'
  }
};

// ─── VARIETY RECOMMENDATIONS BY HEALTH PRIORITY ───────────────────────────────
var varietyByHealth = {
  gut:     { primary: 'broccoli',      secondary: 'red-cabbage', explore: 'coriander' },
  energy:  { primary: 'pea',           secondary: 'sunflower',   explore: 'amaranth' },
  immune:  { primary: 'red-cabbage',   secondary: 'nasturtium',  explore: 'broccoli' },
  overall: { primary: 'sunflower',     secondary: 'pea',         explore: 'popcorn-shoots' }
};

// ─── WILDCARD VARIETY BY LIFESTYLE SIGNAL ─────────────────────────────────────
function getExploreVariety(healthKey, formatKey) {
  // Food lovers get the chef's pick; powder users get portable nutrition; others get the health map
  if (formatKey && formatKey.indexOf('fresh') !== -1) return varietyByHealth[healthKey].explore;
  if (formatKey === 'powder' || formatKey === 'powder-big-shot') return 'amaranth';
  return varietyByHealth[healthKey].explore;
}

// ─── CUSTOMER QUOTES ──────────────────────────────────────────────────────────
// One real quote per format outcome — social proof from someone who matched the same way.
// ← REPLACE ALL PLACEHOLDERS WITH REAL CUSTOMER QUOTES before going live.
// The attr line should be: First name, location (no surname needed).

var customerQuotes = {
  bigshot: {
    text: "Totally reversed my gut issues. Will never be without Big Shot.",
    attr: "Susan R. \u00b7 Verified customer"
  },
  fresh: {
    text: "Finally I have found my microgreens family. They arrive every week fresh and full of life. I cannot recommend them enough.",
    attr: "Jane C. \u00b7 Verified customer"
  },
  powder: {
    text: "I'm more of a meat-and-fats guy. When Tara said I could get a load of veggie goodness in one daily shot \u2014 bring it on. It just feels good going into the body.",
    attr: "Mark Scott \u00b7 Verified customer"
  },
  'fresh-bigshot': {
    text: "A good few months in taking my Big Shot every day. Nails and hair feel stronger, gut feels calmer. I'm hooked.",
    attr: "Theresa Edwards \u00b7 Big Shot subscriber"
  },
  'bigshot-powder': {
    text: "I look forward to drinking my Big Shot every morning \u2014 convenient, effective and tasty. Give it a Shot, you won't be disappointed.",
    attr: "Fiona Barrowman \u00b7 Verified customer"
  },
  'fresh-powder': {
    text: "Fresh at home, powder when I'm away. I haven't had a day without microgreens in months.",
    attr: "Verified customer"
  }
};


// ─── VISUAL TIMELINE (what to expect — 3 phases per format) ───────────────────
// Replaces the expect paragraph with an honest, staged timeline.
var expectTimeline = {
  bigshot: [
    { period: "Week 1", text: "Your gut microbiome begins adjusting to the daily live cultures. Some people notice subtle changes — more regularity, less bloating after meals. Others notice nothing yet. Both are normal; the work is happening." },
    { period: "Weeks 2–3", text: "Most Big Shot customers notice their first clear changes here. More settled digestion, steadier energy through the day, and often better sleep. The live cultures are accumulating and the effect compounds." },
    { period: "Month 1+", text: "The sustained shift. This is where Big Shot earns its reputation. Most subscribers at one month describe their digestion as genuinely transformed — and many find energy and clarity have followed without specifically targeting them." }
  ],
  fresh: [
    { period: "Week 1", text: "You're adding extraordinary nutritional density to your diet. Your body is absorbing concentrated vitamins, minerals and phytonutrients straight from plant to plate, at peak bioavailability." },
    { period: "Weeks 2–3", text: "Energy and a sense of lightness tend to come first. Eating more fresh microgreens naturally crowds out less nutritious food. Digestion often improves as a direct side effect of the extra fibre and phytonutrients." },
    { period: "Month 1+", text: "The nutritional impact accumulates. Many customers describe their baseline health simply shifting upward — nothing dramatic, just consistently better. Most say they notice it most clearly in the weeks they don't have them." }
  ],
  powder: [
    { period: "Week 1", text: "Add it to whatever you already have every morning — coffee, smoothie, porridge. Day one feels unremarkable. The work is happening quietly. The habit is what matters most to establish now." },
    { period: "Weeks 2–3", text: "Digestive regularity and steadier energy are typically the first signs. Consistency is what makes this work — the accumulation effect slows when you miss days, so the routine is everything." },
    { period: "Month 1+", text: "A full month of unbroken use is where the clearest before-and-after appears. Most powder customers describe this as the point where they stopped thinking of it as optional — and noticed immediately when they ran out." }
  ],
  'bigshot-powder': [
    { period: "Week 1", text: "Big Shot every morning at home — 30 seconds and done. Pack the powder for travel. Your routine is consistent from day one, which is the whole point of this combination." },
    { period: "Weeks 2–3", text: "Most people notice digestive and energy changes around week two. Because the nutrition continues even when your routine changes, progress doesn't stall the way it does when you have gaps." },
    { period: "Month 1+", text: "No gaps means no resets. Many Big Shot + powder customers say the combination is precisely why they've maintained the habit long-term when other things didn't stick. Consistency compounds." }
  ],
  'fresh-bigshot': [
    { period: "Week 1", text: "Big Shot each morning builds the daily habit fast — 30 seconds, done, before the day starts. Fresh microgreens appear on the plate when you're cooking in the evening. From day one, you're getting microgreens in two genuinely different ways." },
    { period: "Weeks 2–3", text: "The variety between formats starts to show. On fresh evenings, you'll notice how satisfying it is to eat something you know is exceptional. On Big Shot mornings, the ritual becomes automatic. Most people at this point say they've stopped thinking of it as 'health food' — it's just part of how they eat." },
    { period: "Month 1+", text: "The combination becomes your default. Fresh when you're in cooking mode; Big Shot when you're not. Both microgreens. Both working. Most of our fresh + Big Shot customers stick with this pairing long-term — it fits real life." }
  ],
  'fresh-powder': [
    { period: "Week 1", text: "Fresh microgreens at home, eaten raw across your meals. Powder packed when you're away. From day one, your nutritional baseline is protected regardless of what the week looks like." },
    { period: "Weeks 2–3", text: "Energy and lighter digestion tend to come first. The powder means you don't drop back to zero when fresh isn't available — so the progress from those weeks at home carries through." },
    { period: "Month 1+", text: "Between fresh at home and powder on the go, you build a month of continuous microgreens nutrition — most customers say this is the combination that finally stuck, where others hadn't." }
  ]
};

// ─── FORMAT OUTCOMES ──────────────────────────────────────────────────────────
var formats = {
  bigshot: {
    tag: "Your Match: Big Shot",
    tagClass: "t-gut",
    klaviyoTag: "quiz-bigshot",
    headline: "A daily ritual that does the work for you.",
    what: "Five microgreens — broccoli, red cabbage, pea shoots, sunflower shoots and radish — cold pressed to preserve their nutrients, then wild-fermented. A live product. 30ml every morning. No preparation.",
    products: [
      { name: "Big Shot", badge: "Your match", price: "£19.95/week on subscription · free UK delivery", featured: true }
    ],
    productLink: "/products/big-shot-fermented-microgreen-shots-7-x-30ml-bottles-limited-small-batch",
    productLinkText: "Try Big Shot →",
    tips: [
      "Take it first thing, before breakfast — on an empty stomach for best absorption of the live cultures.",
      "Keep it in the fridge door so it's the first thing you reach for. Habit is everything.",
      "Give it a full month before judging. Fermented products work through accumulation, not overnight."
    ]
  },
  fresh: {
    tag: "Your Match: Fresh Microgreens",
    tagClass: "t-energy",
    klaviyoTag: "quiz-fresh",
    headline: "Real food. Peak nutrition. Nothing processed.",
    what: "Grown in our indoor vertical farm in Perthshire, harvested to order and delivered chilled. Add to salads, eggs, sandwiches, soups — anything. Eaten raw, as food, at the moment of peak nutrient concentration.",
    products: [
      { name: "Fresh Microgreens", badge: "Your match", price: "From £3.45 per punnet depending on variety · chilled delivery · grown in Scotland", featured: true }
    ],
    productLink: "/products/microgreens-fusion-mix-enriched-being-mg",
    productLinkText: "Shop fresh microgreens →",
    tips: [
      "Eat them raw wherever possible — heat destroys the Vitamin C and enzymes that make microgreens exceptional.",
      "Scatter a handful over breakfast as well as lunch. Consistency across the day matters more than quantity at once.",
      "Store upright in the punnet in the fridge. They'll stay fresh for 5–7 days after delivery."
    ]
  },
  powder: {
    tag: "Your Match: Powder",
    tagClass: "t-immune",
    klaviyoTag: "quiz-powder",
    headline: "The same nutrition. Wherever your day takes you.",
    what: "Made from the pulp of our cold-pressed Big Shot process — the same five microgreens, fermented, then dehydrated at 40°C to preserve the live cultures and enzymes. Milled fine. Stir into anything. No fridge needed.",
    products: [
      { name: "Microgreens Powder", badge: "Your match", price: "£12 per 30g pouch · no refrigeration · free UK delivery", featured: true }
    ],
    productLink: "/products/big-shot-fermented-green-powder",
    productLinkText: "Shop the powder →",
    tips: [
      "Add to your morning coffee, smoothie or porridge so it becomes part of a routine you already have.",
      "A level teaspoon per day — it's concentrated, so a little goes further than you'd expect.",
      "Keep a pouch in your bag so you're never without it, whatever the week brings."
    ]
  },
  'bigshot-powder': {
    tag: "Your Match: Big Shot + Powder",
    tagClass: "t-gut",
    klaviyoTag: "quiz-bigshot-powder",
    headline: "Consistent nutrition, whatever the week looks like.",
    what: "Big Shot when you're home — live, fermented, 30ml each morning. Powder when you travel — same five-microgreen ferment, dehydrated at 40°C to preserve the live cultures. Two formats, one plant, no gaps.",
    products: [
      { name: "Big Shot", badge: "At home", price: "£19.95/week subscription · free UK delivery", featured: true },
      { name: "Microgreens Powder", badge: "When travelling", price: "£12 per 30g pouch · no refrigeration needed", featured: false }
    ],
    productLink: "/collections/all",
    productLinkText: "Shop both →",
    tips: [
      "Keep Big Shot in the fridge door — your daily ritual when you're home.",
      "Pack the powder every time you travel. Nutritional continuity when your routine disappears.",
      "Start with Big Shot daily for the first two weeks before adding powder. Let the habit form first."
    ]
  },
  'fresh-bigshot': {
    tag: "Your Match: Fresh + Big Shot",
    tagClass: "t-energy",
    klaviyoTag: "quiz-fresh-bigshot",
    headline: "Real food when you want it. Effortless when you don't.",
    what: "Fresh microgreens on the evenings you're cooking — the full flavour and texture of living plants, added to whatever's on the plate. Big Shot on the days when time is short — 30ml, one moment, done. Two formats built around how your week actually unfolds.",
    products: [
      { name: "Fresh Microgreens", badge: "When you're cooking", price: "From £3.45 per punnet depending on variety · harvested to order · chilled delivery", featured: true },
      { name: "Big Shot", badge: "On busy days", price: "£19.95/week · 30ml daily · no prep · free UK delivery", featured: false }
    ],
    productLink: "/collections/all",
    productLinkText: "Shop both →",
    tips: [
      "Keep fresh punnets in the fridge door — scattered over whatever you're cooking that evening, raw where possible.",
      "Take Big Shot first thing on the days there's no time to think. One moment, done, before your day starts.",
      "Between the two, you're covered. No week is too busy to miss out."
    ]
  },
  'fresh-powder': {
    tag: "Your Match: Fresh + Powder",
    tagClass: "t-energy",
    klaviyoTag: "quiz-fresh-powder",
    headline: "The full experience at home. Covered everywhere else.",
    what: "Fresh microgreens from our Perthshire farm, harvested to order and delivered chilled. The powder made from the same five-microgreen ferment — concentrated, portable, no fridge needed. Two formats, one plant.",
    products: [
      { name: "Fresh Microgreens", badge: "At home", price: "From £3.45 per punnet depending on variety · chilled delivery", featured: true },
      { name: "Microgreens Powder", badge: "When travelling", price: "£12 per 30g pouch · no refrigeration needed", featured: false }
    ],
    productLink: "/collections/all",
    productLinkText: "Shop both →",
    tips: [
      "Order fresh for the weeks you're home — eat across meals, always raw where possible.",
      "Keep a powder pouch in your bag for when you're travelling or life gets complicated.",
      "Between the two, you'll never have a day without your microgreens."
    ]
  }
};

// ─── STATE ────────────────────────────────────────────────────────────────────
var current = 0;
var answers = [];
var selectedAnswerTexts = []; // tracks the actual text of each selected answer
var formatKey = null;
var healthKey = null;

// ─── LOGIC ────────────────────────────────────────────────────────────────────
function getTotals() {
  var totals = {};
  answers.forEach(function(a) {
    Object.keys(a).forEach(function(k) { totals[k] = (totals[k] || 0) + a[k]; });
  });
  return totals;
}

function getHealthPriority(totals) {
  var health = { energy: totals.energy||0, gut: totals.gut||0, immune: totals.immune||0, overall: totals.overall||0 };
  return Object.keys(health).sort(function(a,b){ return health[b]-health[a]; })[0];
}

function getSecondaryHealthPriority(totals) {
  var health = { energy: totals.energy||0, gut: totals.gut||0, immune: totals.immune||0, overall: totals.overall||0 };
  var sorted = Object.keys(health).sort(function(a,b){ return health[b]-health[a]; });
  var primary   = sorted[0];
  var secondary = sorted[1];
  // Skip secondary if it has no points, or if it's 'overall' (too generic), or far below primary
  if (!health[secondary]) return null;
  if (secondary === 'overall') return null;
  if (health[secondary] < health[primary] - 5) return null;
  return secondary;
}

function getFormat(totals) {
  var travel = totals.travel || 0;
  var food   = totals.food   || 0;
  var powder = totals.powder || 0;
  var ritual = totals.ritual || 0;
  var hKey   = getHealthPriority(totals);
  if (travel >= 3) {
    if (hKey === 'gut') return 'bigshot-powder';
    if (food >= 2)      return 'fresh-powder';
    return 'powder';
  }
  if (travel >= 1 && powder >= 2) return 'powder';
  if (travel >= 1 && food >= 2)   return 'fresh-powder';
  if (food >= 2)                  return 'fresh';
  if (food >= 1 && ritual >= 1)   return 'fresh-bigshot';
  if (powder >= 2)                return 'powder';
  return 'bigshot';
}

function setProgress(step, total) {
  document.getElementById('prog').style.width = ((step / total) * 100) + '%';
}

// ─── RENDER QUESTION ──────────────────────────────────────────────────────────
function renderQuestion(idx) {
  var q = questions[idx];
  setProgress(idx, questions.length);

  // Lifestyle divider now fires at Q7 (idx 6) after new aspirational Q6
  var divider = idx === 6
    ? '<p style="font-size:12px;color:#9ca3af;letter-spacing:0.04em;text-transform:uppercase;margin:0 0 1.5rem;border-top:0.5px solid #f3f4f6;padding-top:1.5rem;">A couple of questions about your lifestyle</p>'
    : '';

  var html = '<p class="q-label">Question ' + (idx+1) + ' of ' + questions.length + '</p>';
  html += divider;
  html += '<p class="q-text">' + q.q + '</p><div id="opts">';
  q.opts.forEach(function(o, i) {
    html += '<button class="opt" data-i="' + i + '">' + o.text + '</button>';
  });
  html += '</div>';
  if (idx > 0) html += '<span class="back-l" id="back">← Back</span>';
  html += '<div><button class="nxt" id="nxt">' + (idx+1 === questions.length ? 'See my match →' : 'Next →') + '</button></div>';

  document.getElementById('screen').innerHTML = html;

  var sel = null;
  document.querySelectorAll('.opt').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.opt').forEach(function(b){ b.classList.remove('sel'); });
      btn.classList.add('sel');
      sel = parseInt(btn.dataset.i);
      document.getElementById('nxt').classList.add('on');
    });
  });

  document.getElementById('nxt').addEventListener('click', function() {
    if (sel === null) return;
    answers[idx] = q.opts[sel].scores;
    selectedAnswerTexts[idx] = q.opts[sel].text; // store for personalisation
    if (idx + 1 < questions.length) {
      current++; renderQuestion(current);
    } else {
      var totals = getTotals();
      healthKey  = getHealthPriority(totals);
      formatKey  = getFormat(totals);
      renderResult();
    }
  });

  var back = document.getElementById('back');
  if (back) back.addEventListener('click', function(){ current--; renderQuestion(current); });
}

// ─── RENDER RESULT ────────────────────────────────────────────────────────────
function renderResult() {
  setProgress(questions.length, questions.length);
  var totals       = getTotals();
  var f            = formats[formatKey];
  var science      = scienceCopy[healthKey];
  var secondaryKey = getSecondaryHealthPriority(totals);
  var answerOpener = getAnswerOpener(healthKey, selectedAnswerTexts);
  var quote        = customerQuotes[formatKey];
  var timeline     = expectTimeline[formatKey];
  var isCombo      = f.products.length > 1;

  var html = '';

  // ── 1. Format tag + headline + what (ALWAYS VISIBLE — no gate)
  html += '<div class="card">';
  html += '<span class="rtag ' + f.tagClass + '">' + f.tag + '</span>';
  html += '<p style="font-size:19px;font-weight:500;color:#111;margin:0 0 0.75rem;line-height:1.3;">' + f.headline + '</p>';
  html += '<p class="res-body">' + f.what + '</p>';
  html += '</div>';

  // ── EMAIL GATE — shown immediately after format reveal
  html += '<div class="card" id="gate-card">';
  html += '<p style="font-size:15px;font-weight:500;color:#111;margin:0 0 0.25rem;">See your full personalised plan</p>';
  html += '<p style="font-size:13px;color:#6b7280;margin:0 0 1rem;line-height:1.6;">Enter your email to unlock your health rationale, variety recommendations, product guide and a first-order discount.</p>';
  html += '<input class="email-in" type="text" id="name-in" placeholder="First name" />';
  html += '<input class="email-in" type="email" id="email-in" placeholder="your@email.com" />';
  html += '<button class="sub-btn" id="sub-btn">Unlock my full match →</button>';
  html += '<p class="err-msg" id="err-msg">Please enter a valid email address.</p>';
  html += '<p style="font-size:11px;color:#9ca3af;margin:0.75rem 0 0;text-align:center;">No spam. Unsubscribe any time.</p>';
  html += '</div>';

  // ── GATED CONTENT — hidden until email submitted
  html += '<div id="gated-content" style="display:none;">';
  html += '<div class="card">';

  // ── 2. Health signal badges + answer-referencing opener + interpretation
  html += '<div class="res-section" style="border-top:none;padding-top:0;margin-top:0;">';
  html += '<p class="res-section-label">What your answers suggest</p>';
  html += '<div class="signal-badges">';
  html += '<span class="sig-badge sig-primary-' + healthKey + '">' + healthLabels[healthKey] + '</span>';
  if (secondaryKey) {
    html += '<span class="sig-badge sig-secondary">+ ' + healthLabels[secondaryKey] + '</span>';
  }
  html += '</div>';
  if (answerOpener) {
    html += '<p class="answer-opener">' + answerOpener + '</p>';
  }
  html += '<p class="res-body">' + signalsCopy[healthKey] + '</p>';
  if (secondaryKey) {
    html += '<p class="res-body" style="margin-top:0.5rem;">Your answers also flagged <strong>' + healthLabels[secondaryKey].toLowerCase() + '</strong> — ' + secondarySignalNote[secondaryKey] + '.</p>';
  }
  html += '</div>';

  // ── 3. Why this format for this health priority
  html += '<div class="res-section">';
  html += '<p class="res-section-label">Why ' + f.tag.replace('Your Match: ', '') + ' suits you</p>';
  html += '<p class="res-body">' + formatHealthCopy[formatKey][healthKey] + '</p>';
  html += '</div>';

  // ── 3b. Variety recommendation
  var vRec       = varietyByHealth[healthKey];
  var vPrimary   = varietyData[vRec.primary];
  var vSecondary = varietyData[vRec.secondary];
  var vExplore   = varietyData[getExploreVariety(healthKey, formatKey)];

  html += '<div class="res-section">';
  html += '<p class="res-section-label">Your recommended variety</p>';
  html += '<div class="variety-card">';
  html += '<div class="variety-primary">';
  html += '<div class="variety-header">';
  html += '<span class="variety-name">' + vPrimary.name + '</span>';
  html += '<span class="variety-tagline">' + vPrimary.tagline + '</span>';
  html += '</div>';
  html += '<p class="variety-why">' + vPrimary.why[healthKey] + '</p>';
  html += '<p class="variety-flavour">✦ ' + vPrimary.flavour + '</p>';
  html += '<div class="variety-meta"><span class="variety-size">' + vPrimary.size + '</span><span class="variety-price">' + vPrimary.price + '</span></div>';
  html += '</div>';
  html += '<div class="variety-secondary">';
  html += '<p class="variety-also">Also well-matched: <strong>' + vSecondary.name + '</strong> — ' + vSecondary.tagline.toLowerCase() + '. ' + vSecondary.flavour + ' ' + vSecondary.size + ' · ' + vSecondary.price + '</p>';
  html += '</div>';
  html += '<div class="variety-explore">';
  html += '<p class="variety-explore-label">Worth exploring</p>';
  html += '<p class="variety-explore-body"><strong>' + vExplore.name + '</strong> — ' + vExplore.tagline + '. ' + vExplore.why[healthKey] + '</p>';
  html += '</div>';
  html += '</div>';
  html += '<p class="variety-note">Our Fusion Mix and Big Shot both contain multiple varieties — including those recommended above — optimised to work together.</p>';
  html += '</div>';

  // ── 4. Product recommendation + CTA
  html += '<div class="res-section">';
  html += '<p class="res-section-label">' + (isCombo ? 'Your two formats' : 'Your recommendation') + '</p>';
  if (isCombo) {
    html += '<div class="sub-grid">';
    f.products.forEach(function(pr) {
      html += '<div class="sub-card' + (pr.featured ? ' featured' : '') + '">';
      html += '<p class="sc-badge">' + pr.badge + '</p>';
      html += '<p class="sc-name">' + pr.name + '</p>';
      html += '<p class="sc-detail">' + pr.price + '</p>';
      html += '</div>';
    });
    html += '</div>';
  } else {
    var pr = f.products[0];
    html += '<div class="sub-card featured" style="margin-top:0.5rem;">';
    html += '<p class="sc-badge">' + pr.badge + '</p>';
    html += '<p class="sc-name">' + pr.name + '</p>';
    html += '<p class="sc-detail">' + pr.price + '</p>';
    html += '</div>';
  }
  html += '<div style="margin-top:1rem;">';
  html += '<a href="' + f.productLink + '" style="display:inline-block;padding:11px 22px;background:#3B6D11;color:#EAF3DE;text-decoration:none;border-radius:8px;font-size:14px;font-weight:500;">' + f.productLinkText + '</a>';
  html += '</div>';
  html += '</div>';

  // ── 5. Customer quote (social proof)
  html += '<div class="res-section">';
  html += '<p class="res-section-label">From someone who matched the same way</p>';
  html += '<div class="quote-box">';
  html += '<p class="quote-text">"' + quote.text + '"</p>';
  html += '<p class="quote-attr">— ' + quote.attr + '</p>';
  html += '</div>';
  html += '</div>';

  // ── 6. The research (with vivid stat translations)
  html += '<div class="res-section">';
  html += '<p class="res-section-label">What the research shows</p>';
  html += '<p class="res-body" style="margin-bottom:0.25rem;">' + science.intro + '</p>';
  html += '<ul class="research-list">';
  science.facts.forEach(function(fact) {
    html += '<li>' + fact.text + ' <span class="research-ref">(' + fact.ref + ')</span></li>';
  });
  html += '</ul>';
  html += '<a href="/pages/the-science" class="science-link">Read the full research →</a>';
  html += '</div>';

  // ── 7. Visual timeline (what to expect)
  html += '<div class="res-section">';
  html += '<p class="res-section-label">What to expect</p>';
  html += '<div class="timeline">';
  timeline.forEach(function(phase) {
    html += '<div class="tl-step">';
    html += '<div class="tl-left"><div class="tl-dot"></div><div class="tl-line"></div></div>';
    html += '<div style="flex:1"><p class="tl-period">' + phase.period + '</p><p class="tl-body">' + phase.text + '</p></div>';
    html += '</div>';
  });
  html += '</div>';
  html += '</div>';

  // ── 8. Getting started tips
  html += '<div class="res-section">';
  html += '<p class="res-section-label">Getting started</p>';
  html += '<ul class="tip-list">';
  f.tips.forEach(function(t){ html += '<li>' + t + '</li>'; });
  html += '</ul>';
  html += '</div>';

  html += '</div>'; // end gated card
  html += '</div>'; // end gated-content div

  html += '<span class="back-l" id="retake">← Retake quiz</span>';

  document.getElementById('screen').innerHTML = html;

  document.getElementById('sub-btn').addEventListener('click', function() {
    var email  = document.getElementById('email-in').value.trim();
    var name   = document.getElementById('name-in').value.trim();
    var errMsg = document.getElementById('err-msg');
    if (!email || !email.includes('@') || !email.includes('.')) {
      document.getElementById('email-in').style.borderColor = '#dc2626';
      errMsg.style.display = 'block';
      return;
    }
    errMsg.style.display = 'none';
    // Submit to Klaviyo (non-blocking — don't make people wait)
    submitToKlaviyo(email, name, f, function() {});
    // Reveal gated content immediately
    document.getElementById('gate-card').style.display = 'none';
    document.getElementById('gated-content').style.display = 'block';
    setTimeout(function() {
      document.getElementById('gated-content').scrollIntoView({behavior:'smooth',block:'start'});
    }, 80);
  });

  document.getElementById('retake').addEventListener('click', function() {
    current = 0; answers = []; selectedAnswerTexts = [];
    renderQuestion(0);
  });
}

// ─── KLAVIYO SUBMISSION ───────────────────────────────────────────────────────
// Now also passes aspirational_goal (from Q6) as a profile property.
function submitToKlaviyo(email, name, format, callback) {
  var btn = document.getElementById('sub-btn');
  btn.disabled = true;
  btn.textContent = 'Sending...';
  var payload = {
    data: {
      type: "subscription",
      attributes: {
        profile: {
          data: {
            type: "profile",
            attributes: {
              email: email,
              first_name: name || '',
              properties: {
                format_recommendation: formatKey,
                health_priority:       healthKey,
                aspirational_goal:     selectedAnswerTexts[5] || '',
                quiz_source:           "enrichedbeing-match-quiz"
              }
            }
          }
        },
        custom_source: format.klaviyoTag
      },
      relationships: {
        list: { data: { type: "list", id: KLAVIYO_LIST_ID } }
      }
    }
  };
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': '2023-12-15' },
    body: JSON.stringify(payload)
  })
  .then(function(res){ callback(res.ok || res.status === 202); })
  .catch(function(){ callback(false); });
}

// ─── SUCCESS ──────────────────────────────────────────────────────────────────
function renderSuccess(name, tag) {
  setProgress(questions.length, questions.length);
  document.getElementById('screen').innerHTML =
    '<div class="success">' +
    '<div class="tick">✦</div>' +
    '<p style="font-size:18px;font-weight:500;color:#111;margin:0 0 0.5rem;">On its way, ' + name + '!</p>' +
    '<p style="font-size:14px;color:#6b7280;line-height:1.6;margin:0 0 1.5rem;">Your ' + tag + ' is heading to your inbox. Check your junk folder if it doesn\'t arrive within a few minutes.</p>' +
    '<a href="/collections/all" style="display:inline-block;padding:11px 24px;background:#3B6D11;color:#EAF3DE;text-decoration:none;border-radius:8px;font-size:14px;font-weight:500;">Shop your match →</a>' +
    '</div>';
}

renderQuestion(0);
